import { AlertCircle, Camera, Eye, EyeOff, Lock, Save, Shield, User } from 'lucide-react';
import { useState, useEffect, useContext } from 'react';
import "../../assets/css/vendors/HotelScreens/hotelPasswordReset.css";
import VendorLayout from "../../layout/HotelVendorLayout/VendorLayout";
import axios from 'axios'; 
import AppContext from "../../context/AppContext";

const HotelProfileSetting = () => {
  const { baseUrl, validateField, authToken } = useContext(AppContext);  // ← CHANGE 1: authToken added
  
  const [activeTab, setActiveTab] = useState('profile');
  const [loading, setLoading] = useState(true); 
  const [vendorId] = useState(localStorage.getItem("vendorId")); 
  
  const [profile, setProfile] = useState({
    name: '',
    email: '',
    phone: '',
    role: ''
  });
  const [profileMsg, setProfileMsg] = useState({ text: '', type: '' });
  const [nameError, setNameError] = useState("");
  const [passwords, setPasswords] = useState({ current: '', new: '', confirm: '' });
  const [showPw, setShowPw] = useState({ current: false, new: false, confirm: false });
  const [passwordMsg, setPasswordMsg] = useState({ text: '', type: '' });

  useEffect(() => {
    console.log("1. useEffect started");
    console.log("2. vendorId:", vendorId);
    
    if (!vendorId) {
      console.log("3. No vendorId, setting loading false");
      setLoading(false);
      return;
    }

    console.log("4. Making API call to:", `${baseUrl}/vendor/get`);
    
    axios.get(`${baseUrl}/vendor/get`, {
      params: { vendor_id: vendorId },
      headers: { 
        'Authorization': `Bearer ${authToken}`
      }
    })
    .then(response => {
      console.log("5. API Success:", response.data);
      const vendor = response.data.data;
      console.log("6. Vendor data:", vendor);
      
      setProfile({
        name: vendor.name || '',
        email: vendor.email || '',
        phone: vendor.phone || '',
        role: vendor.role || 'Vendor'
      });
      setLoading(false); 
    })
    .catch(error => {
      console.log("7. API Error:", error);
      setProfileMsg({ text: 'Failed to load profile data', type: 'error' });
      setLoading(false);  
    });
  }, [vendorId, baseUrl, authToken]); 
  const handleProfileChange = (field, value) => {
    setProfile(prev => ({ ...prev, [field]: value }));
    if (profileMsg.text) setProfileMsg({ text: '', type: '' });
    if (field === 'name') {
      setNameError('');
    }
  };

  const handleUpdateProfile = () => {
  const nameErr = validateField('name', profile.name);
    setNameError(nameErr);
    
    if (nameErr) {
      setProfileMsg({ text: nameErr, type: 'error' });
      return;
    }

    setProfileMsg({ text: 'Updating profile...', type: 'info' });

    const formData = new FormData();
    formData.append('vendor_id', vendorId);
    formData.append('name', profile.name);

    axios.post(`${baseUrl}/vendor/update`, formData, {
      headers: { 
        'Content-Type': 'multipart/form-data',
        'Authorization': `Bearer ${authToken}`  
      }
    })
    .then(response => {
      console.log(response.data); 
      if (response.data.success) {
        setProfileMsg({ text: 'Profile updated successfully!', type: 'success' });
        setProfile(prev => ({
          ...prev,
          name: response.data.vendor.name,
        }));
        setNameError(''); 
      } else {
        setProfileMsg({ text: response.data.message || 'Update failed', type: 'error' });
      }
    })
    .catch(error => {
      const errorMsg = error.response?.data?.message || 'Failed to update profile';
      setProfileMsg({ text: errorMsg, type: 'error' });
    })
    .finally(() => {
      setTimeout(() => setProfileMsg({ text: '', type: '' }), 3000);
    });
  };

  const handlePasswordChange = (field, value) => {
    setPasswords(prev => ({ ...prev, [field]: value }));
    if (passwordMsg.text) setPasswordMsg({ text: '', type: '' });
  };

const handleUpdatePassword = () => {
    if (passwords.current === "") {
        setPasswordMsg({ text: 'Please enter your current password!', type: 'error' });
        return;
    }
    const newPwError = validateField('password', passwords.new);
    if (newPwError) {
        setPasswordMsg({ text: newPwError, type: 'error' });
        return;
    }
    if (passwords.new !== passwords.confirm) {
        setPasswordMsg({ text: 'Passwords do not match!', type: 'error' });
        return;
    }
    setPasswordMsg({ text: 'Updating password...', type: 'info' });

    axios.post(`${baseUrl}/vendor/update-password`, {
        current_password: passwords.current,
        new_password: passwords.new,
    }, {
        headers: {
            Authorization: `Bearer ${authToken}`
        }
    })
    .then(response => {
        if (response.data.success) {
            setPasswordMsg({ text: 'Password updated successfully!', type: 'success' });
            setPasswords({ current: '', new: '', confirm: '' });
        } else {
            setPasswordMsg({ text: response.data.message || 'Update failed', type: 'error' });
        }
    })
    .catch(error => {
        const errorMsg = error.response?.data?.message || 'Failed to update password';
        setPasswordMsg({ text: errorMsg, type: 'error' });
    })
    .finally(() => {
        setTimeout(() => setPasswordMsg({ text: '', type: '' }), 3000);
    });
};

  const tabs = [
    { id: 'profile', label: 'Profile', icon: <User size={18} /> },
    { id: 'password', label: 'Password', icon: <Lock size={18} /> },
  ];

  return (
    <VendorLayout>
      <div className="hps-container">
        <div className="hps-layout">

          <div className="hps-sidebar">
            {tabs.map(tab => (
              <button
                key={tab.id}
                className={`hps-tab-btn ${activeTab === tab.id ? 'hps-tab-active' : ''}`}
                onClick={() => setActiveTab(tab.id)}
              >
                {tab.icon}
                <span>{tab.label}</span>
              </button>
            ))}
          </div>

          <div className="hps-content">

            {loading ? (
              <div style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                height: '400px'
              }}>
                <div className="spinner-border text-warning" role="status">
                  <span className="visually-hidden">Loading...</span>
                </div>
              </div>
            ) : (
              <>
                {activeTab === 'profile' && (
                  <>
                    <div className="hps-content-header">
                      <User size={22} />
                      <div>
                        <h2 className="hps-content-title">Profile Information</h2>
                        <p className="hps-content-subtitle">Update your personal details</p>
                      </div>
                    </div>

                    <div className="hps-card">
                      <div className="hps-avatar-section">
                        <div className="hps-avatar-wrap">
                          <div className="hps-avatar">
                            {profile.name ? profile.name.charAt(0).toUpperCase() : 'V'}
                          </div>
                        <span className="hps-avatar-btn"></span>

                        </div>
                        <div className="hps-avatar-info">
                          <h3 className="hps-avatar-name">{profile.name || 'Vendor Name'}</h3>
                          <p className="hps-avatar-role">{profile.role}</p>
                        </div>
                      </div>

                      <div className="hps-divider" />

                      <div className="hps-form-grid">
                        <div className="hps-form-group">
                          <label className="hps-label"><User size={13} /> Full Name *</label>
                          <input
                            type="text"
                            className={`hps-input ${nameError ? 'is-invalid' : ''}`}
                            value={profile.name}
                            onChange={(e) => handleProfileChange('name', e.target.value)}
                            placeholder="Enter full name"
                          />
                          {nameError && <div className="invalid-feedback" style={{ color: '#dc3545', fontSize: '0.875rem', marginTop: '0.25rem' }}>{nameError}</div>}
                        </div>

                        <div className="hps-form-group">
                         <label className="hps-label"> Email Address *</label>
                          <input
                           type="email"
                           className="hps-input hps-input-disabled"  
                           value={profile.email}
                           placeholder="Enter email"/>
                        </div>

                        <div className="hps-form-group">
                          <label className="hps-label">Role</label>
                          <input
                            type="text"
                            className="hps-input hps-input-disabled"
                            value={profile.role}
                            readOnly
                          />
                        </div>
                      </div>

                      <div className="hps-divider" />

                      {profileMsg.text && (
                        <p className={`hps-msg hps-msg-${profileMsg.type}`}>{profileMsg.text}</p>
                      )}

                      <div className="hps-action-row">
                        <button 
                          className="hps-save-btn" 
                          onClick={handleUpdateProfile}
                          disabled={profileMsg.text === 'Updating profile...'}
                        >
                          <Save size={16} />
                          {profileMsg.text === 'Updating profile...' ? 'Updating...' : 'Update Profile'}
                        </button>
                      </div>
                    </div>
                  </>
                )}

                {activeTab === 'password' && (
                  <>
                    <div className="hps-content-header">
                      <Shield size={22} />
                      <div>
                        <h2 className="hps-content-title">Change Password</h2>
                        <p className="hps-content-subtitle">Keep your account secure</p>
                      </div>
                    </div>

                    <div className="hps-card">
                      <div className="hps-security-alert">
                        <AlertCircle size={18} />
                        <p>Choose a strong password you don't use for other accounts.</p>
                      </div>

                      <div className="hps-pw-form">
                        <div className="hps-form-group hps-full-width">
                          <label className="hps-label">Current Password</label>
                          <div className="hps-pw-wrap">
                            <input
                              type={showPw.current ? 'text' : 'password'}
                              className="hps-input"
                              placeholder="Enter current password"
                              value={passwords.current}
                              onChange={(e) => handlePasswordChange('current', e.target.value)}
                            />
                            <button className="hps-eye-btn" onClick={() => setShowPw(p => ({ ...p, current: !p.current }))}>
                              {showPw.current ? <Eye size={18} /> : <EyeOff size={18} />}
                            </button>
                          </div>
                        </div>

                        <div className="hps-form-group">
                          <label className="hps-label">New Password</label>
                          <div className="hps-pw-wrap">
                            <input
                              type={showPw.new ? 'text' : 'password'}
                              className="hps-input"
                              placeholder="Enter new password"
                              value={passwords.new}
                              onChange={(e) => handlePasswordChange('new', e.target.value)}
                            />
                            <button className="hps-eye-btn" onClick={() => setShowPw(p => ({ ...p, new: !p.new }))}>
                              {showPw.new ? <Eye size={18} /> : <EyeOff size={18} />}
                            </button>
                          </div>
                        </div>

                        <div className="hps-form-group">
                          <label className="hps-label">Confirm New Password</label>
                          <div className="hps-pw-wrap">
                            <input
                              type={showPw.confirm ? 'text' : 'password'}
                              className="hps-input"
                              placeholder="Confirm new password"
                              value={passwords.confirm}
                              onChange={(e) => handlePasswordChange('confirm', e.target.value)}
                            />
                            <button className="hps-eye-btn" onClick={() => setShowPw(p => ({ ...p, confirm: !p.confirm }))}>
                              {showPw.confirm ? <Eye size={18} /> : <EyeOff size={18} />}
                            </button>
                          </div>
                        </div>
                      </div>

                      <div className="hps-divider" />

                      {passwordMsg.text && (
                        <p className={`hps-msg hps-msg-${passwordMsg.type}`}>{passwordMsg.text}</p>
                      )}

                      <div className="hps-action-row">
                        <button className="hps-save-btn" onClick={handleUpdatePassword}>
                          <Save size={16} />
                          Update Password
                        </button>
                      </div>
                    </div>
                  </>
                )}
              </>
            )}

          </div>
        </div>
      </div>
    </VendorLayout>
  );
};

export default HotelProfileSetting;
